<p>
  diagrams works!
</p>
